import { itemHelper } from '../../common/src/helpers'
import React, { useCallback } from 'react'
import { ShimmerVirtualizedList } from '../list/ShimmerVirtualizedList'
import { ItemCell } from './ItemCell'
import { useNarrowWidth } from '../../hooks/useNarrowWidth'
import { GhostItemCell } from './GhostItemCell'

export const ItemVirtualizedList = ({ items, addedItems, selectedItem, onSelectItem, onAddItem, ...rest }) => {
  const narrow = useNarrowWidth()

  const selectedItemID = itemHelper.getId(selectedItem)
  const rowRenderer = useCallback(
    ({ key, index, style }) => {
      const item = items[index]
      const serverID = itemHelper.getId(item)
      const selected = serverID === selectedItemID
      const added = !!addedItems?.has(serverID)
      return (
        <ItemCell
          key={key}
          item={item}
          onClick={onSelectItem}
          onAdd={onAddItem}
          selected={selected}
          added={added}
          style={style}
          narrow={narrow}
        />
      )
    },
    [items, onSelectItem, onAddItem, selectedItemID, narrow, addedItems]
  )

  return <ShimmerVirtualizedList rows={items} rowRenderer={rowRenderer} shimmerComponent={GhostItemCell} {...rest} />
}
